module.exports = __webpack_public_path__ + "static/banner-three-shape8-d5581ec9f24f5131ad31118ad16d6b27.png";